module.exports = __webpack_public_path__ + "static/img/product_1.67120bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_1.jpg
// module id = JgKB
// module chunks = 1